var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("品牌精选活动管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search_criteria" },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "0" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入品牌名称", clearable: "" },
                    model: {
                      value: _vm.queryData.brandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryData, "brandName", $$v)
                      },
                      expression: "queryData.brandName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "选择所属类目",
                  },
                  on: {
                    "visible-change": function ($event) {
                      return _vm.selcetShow($event)
                    },
                  },
                  model: {
                    value: _vm.queryData.categoryId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "categoryId", $$v)
                    },
                    expression: "queryData.categoryId",
                  },
                },
                _vm._l(_vm.categoryOption, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.categoryName, value: item.id },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择上下架状态", clearable: "" },
                      model: {
                        value: _vm.queryData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryData, "status", $$v)
                        },
                        expression: "queryData.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "下架" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: 1, label: "上架" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex",
                  staticStyle: { width: "fit-content", height: "40px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { height: "40px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.onInquire },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "ml10",
                      staticStyle: { height: "40px" },
                      attrs: { type: "info", plain: "" },
                      on: { click: _vm.onInitialize },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.addBrand },
                    },
                    [_vm._v("新增品牌")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showCategoryPop()
                        },
                      },
                    },
                    [_vm._v("类目管理")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.activityAdmin()
                        },
                      },
                    },
                    [_vm._v("编辑活动信息")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "排序", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "品牌名称", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.brandName))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "头图", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [
                            scope.row.logoUrl
                              ? _c("el-image", {
                                  staticStyle: {
                                    display: "block",
                                    width: "80px",
                                  },
                                  attrs: {
                                    src: scope.row.logoUrl,
                                    fit: "scale-down",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "所属类目", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.categoryName))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "上下架状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#13ce66",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.allChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "扩展操作", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "info" },
                            on: {
                              click: function ($event) {
                                return _vm.result(scope.row)
                              },
                            },
                          },
                          [_vm._v("导入结果")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.goodsAdmin(scope.row)
                              },
                            },
                          },
                          [_vm._v("商品详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "类目管理",
            width: "50%",
            top: "2vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "search_criteria" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-left": "0" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "输入类目名称查询", clearable: "" },
                      model: {
                        value: _vm.categoryName,
                        callback: function ($$v) {
                          _vm.categoryName = $$v
                        },
                        expression: "categoryName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { width: "fit-content", height: "40px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { height: "40px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.categorySearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml10",
                        staticStyle: { height: "40px" },
                        attrs: { type: "info", plain: "" },
                        on: { click: _vm.categoryReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.categoryAdd()
                          },
                        },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "20px" },
                  attrs: {
                    "header-cell-style": { "text-align": "center" },
                    "cell-style": { "text-align": "center" },
                    data: _vm.categoryData,
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "排序", width: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.showIpt
                              ? _c("span", [_vm._v(_vm._s(scope.row.sort))])
                              : _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入类目排序",
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.sort,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "sort", $$v)
                                    },
                                    expression: "scope.row.sort",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "类目名称", width: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.showIpt
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.categoryName)),
                                ])
                              : _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入类目名称",
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.categoryName,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "categoryName", $$v)
                                    },
                                    expression: "scope.row.categoryName",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveCategory(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.showIpt ? "保存" : "编辑")
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.del_category(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("activityPop", { ref: "activityPop" }),
      _vm._v(" "),
      _c("resultPop", { ref: "resultPop" }),
      _vm._v(" "),
      _c("brandPop", { ref: "brandPop", on: { refresh: _vm.onInquire } }),
      _vm._v(" "),
      _c("goodsPop", { ref: "goodsPop" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }